// src/app/store.js
import { configureStore } from '@reduxjs/toolkit';
import authReducer from '../features/auth/authSlice';
import businessReducer from '../features/business/businessSlice';
import bookingReducer from '../features/booking/bookingSlice';
import amenityReducer from '../features/amenity/amenitySlice';
import barPreferenceReducer from '../features/bar-preference/barPreferenceSlice';
import trendReducer from '../features/trend/trendSlice';
import categoryReducer from '../features/category/categorySlice';
import cuisineReducer from '../features/cuisine/cuisineSlice';
import dietaryPreferenceReducer from '../features/dietary-preference/dietaryPreferenceSlice';
import occasionReducer from '../features/occasion/occasionSlice';
import userReducer from '../features/user/userSlice';
import itemReducer from '../features/item/itemSlice';
import postReducer from '../features/post/postSlice';
import threadReducer from '../features/thread/threadSlice';
import activityReducer from '../features/activity/activitySlice';
import keywordCategoryReducer from '../features/keyword-category/keywordCategorySlice';
import businessKeywordsCategoriesReducer from '../features/business-keywords-categories/businessKeywordsCategoriesSlice';
// import other slices...

export const store = configureStore({
  reducer: {
    auth: authReducer,
    business: businessReducer,
    booking: bookingReducer,
    amenity: amenityReducer,
    barPreference: barPreferenceReducer,
    trend: trendReducer,
    category: categoryReducer,
    cuisine: cuisineReducer,
    dietaryPreference: dietaryPreferenceReducer,
    occasion: occasionReducer,
    user: userReducer,
    item: itemReducer,
    post: postReducer,
    thread: threadReducer,
    activity: activityReducer,
    keywordCategory: keywordCategoryReducer,
    businessKeywordsCategories: businessKeywordsCategoriesReducer,
  },
});

export default store;
